import { DefineComponentProps } from 'utils'

import { PositionItemLayout } from '../layouts/PositionInfo.layout'
import { useBaseInfoStore, useExchangeInfoStore, useProjectTheme, useUserCenterContractOrderStore } from 'store'
import { useI18n } from 'i18n-utils'
import { OrderDirection } from 'network'
import { ListCell, Pnl, Tag, UiUtils } from '..'
import { dayjs } from 'element-plus'
import classNames from 'classnames'

interface HistoricalEntrustItemProps {
  data: ApiResponse.HistoricalCommission
  divider?: boolean
}

export const HistoricalEntrustItem = defineComponent<HistoricalEntrustItemProps>({
  props: DefineComponentProps<HistoricalEntrustItemProps>(['data', 'divider']),
  setup(props) {
    const baseInfoStore = useBaseInfoStore()
    const exchangeStore = useExchangeInfoStore()
    const themeStore = useProjectTheme()
    const theme = computed(() => themeStore.theme)
    const { t } = useI18n()
    const contractOrderListStore = useUserCenterContractOrderStore()
    const coinIcon = computed(() => {
      const url = baseInfoStore.getContractCoinIconUrlBySymbolId(props.data.symbolId)
      return url || ''
    })

    const { status, statusColor } = contractOrderListStore.getHistoricalCommissionStatus(props.data)

    const openEntrustDetail = () => {
      UiUtils.showEntrustDetail({
        trustId: props.data.trustId.toString(),
        entrust: props.data,
      })
    }

    return () => {
      return (
        <PositionItemLayout class={classNames('position-item', { divider: props.divider })} onClick={openEntrustDetail}>
          <div class="symbol-coin-info">
            <img width={32} height={32} src={coinIcon.value} alt="coin icon" />
            <div class="coin-info">
              <div class="coin-name">
                {exchangeStore.getContractSymbolName(props.data.symbolId)} {t('永续')}
              </div>

              <div class="flex info-tags gap-4">
                <Tag color={props.data.direction === OrderDirection.Buy ? theme.value.colors.up : theme.value.colors.down}>{contractOrderListStore.getOrderType(props.data)}</Tag>
                <Tag color={theme.value.colors.text.base} bgColor={theme.value.colors.bg.tag.base}>
                  {props.data.marginType === 1 ? t('逐仓') : t('全仓')}
                  {props.data.leverage}X
                </Tag>
              </div>
            </div>
            <div class="status" style={{ color: statusColor }}>
              {status}
            </div>
          </div>
          <div class="position-info">
            {/* 已实现盈亏 */}
            <ListCell title={t('已实现盈亏')} description={<Pnl value={props.data.rlzPnl}>USDT</Pnl>} />
            {/* 委托总量 */}
            <ListCell title={t('委托总量')} description={`${contractOrderListStore.getCommissionQty(props.data).formatNumberWithCommas()} USDT`} />
            {/* 已成交总量 */}
            <ListCell title={t('已成交总量')} description={`${contractOrderListStore.getDealInterestQty(props.data).formatNumberWithCommas()} USDT`} />
            {/* 成交均价 */}
            <ListCell title={t('成交均价')} description={`${props.data.avgPrice.formatNumberWithCommas()} USDT`} />
            {/* 创建时间 */}
            <ListCell title={t('创建时间')} description={dayjs(props.data.createTime).format('YYYY-MM-DD HH:mm:ss')} />
          </div>
        </PositionItemLayout>
      )
    }
  },
})
